import router from "../router";
import ua from "@tp/ua";
import debounce from "lodash/debounce";
import { statStayEnd } from "../utils/h5-report";
import { getPageName, setLastp } from "../utils/cntp";
import { setStorage } from "../utils/storage";
/**
 * 转换成url字符串
 * @param {string} url
 * @param {object} params
 * @returns
 */
export const buildEncodeUrl = (url, params) => {
  let paramsArr = [];
  Object.keys(params).forEach((key) => {
    paramsArr.push(`${key}=${encodeURIComponent(params[key])}`);
  });

  return `${url}?${paramsArr.join("&")}`;
};

/**
 * 获取url所有参数
 * @param {string} url
 * @returns Object
 */
export const getUrlParams = (url) => {
  url = url || window.location.search;
  const params = {};

  if (!url.includes("?")) {
    return params;
  }

  const paramsUrl = url.split("?")[1];
  paramsUrl.split("&").forEach((item) => {
    const arr = item.split("=");
    if (arr[1].includes("#")) {
      arr[1] = arr[1].split("#")[0];
    }
    params[arr[0]] = arr[1];
  });

  return params;
};

/**
 * 构建url字符串
 * @param {string} url
 * @param {Object} param
 * @returns
 */
export const buildUrlParams = (url, params) => {
  const path = url.split("?")[0];

  const queryParams = {
    ...getUrlParams(url),
    ...params,
  };

  const arr = [];
  Object.keys(queryParams).forEach((key) => {
    if (queryParams[key] === void 0 || queryParams[key] === null) {
      return true;
    }

    arr.push(`${key}=${queryParams[key]}`);
  });

  return arr.length ? `${path}?${arr.join("&")}` : path;
};

/**
 * 获取url指定参数
 * @param {string} name
 * @param {string} url
 * @returns
 */
export function getQuery(name, url) {
  if (!name) {
    return "";
  }

  const math = new RegExp("[?|&]" + name + "=([^&#]*)(\\s|&|#|$)", "i").exec(
    url || window.location.href
  );

  return math ? math[1] : "";
}

/**
 * 跳转指定页面 - 如果在站内有 schema 优先跳转 schema
 * @param {string} url 跳转的url
 * @param {boolean} replace 是否清除路由跳转
 * @returns
 */
export function jumpSchemaAndUrl(item, replace) {
  let url = item.url1;
  // 如果是在 app 内，则优先使用 schema跳转
  if (ua.isImgo()) {
    if (item.schema1) {
      url = item.schema1;
    } else {
      url = item.url1;
    }
  }
  if (!url) {
    return;
  }
  // 跳转
  jumpPageDebounce(url, replace);
}

/**
 * 跳转指定页面
 * @param {string} url 跳转的url
 * @returns
 */
export function jumpPage(url, replace) {
  if (!url) {
    return;
  }
  jumpPageDebounce(url, replace);
}

// 页面跳转防抖处理
const jumpPageDebounce = debounce(
  function (url, replace) {
    statStayEnd();
    // 此种方式跳转就清除lastp
    setStorage("superlive-lastp", getPageName());
    setLastp(getPageName());
    const isDev = url.indexOf("imgotv://") !== -1;
    if (ua.isImgo() && !isDev) {
      window.location.href = url;
    } else {
      setTimeout(() => {
        if (replace) {
          window.location.replace(url);
          return;
        }
        window.location.href = url;
      }, 400);
    }
  },
  1000,
  { leading: true, trailing: false }
);

/**
 * this.$router.push 方式跳转
 * @param {string} url
 * @param {object} params
 * @returns
 */
export function pushJumpNog(url, params) {
  router.push({
    path: url,
    query: params,
  });
}

/**
 * this.$router.replace 方式跳转
 * @param {string} url
 * @param {object} params
 * @returns
 */
export function replaceJumpNog(url, params) {
  router.replace({
    path: url,
    query: params,
  });
}
